"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEnvelopeBySequenceId = exports.getTransactionBySplitFrom = exports.getTransactionById = exports.getTransactionsByPaymentAppAddressee = exports.getTransactionsByExpense = exports.getTransactionsByBusinessName = exports.isTransactionInEnvelope = exports.findSourceTransactionsByTransactionId = exports.findTargetTransactionsByTrackingCategory = exports.findTargetTransactionsByExpenseCategory = exports.findTrackingCategoryEnvelope = exports.findRecurringEnvelope = exports.findEconomyEnvelope = exports.createTrackingCategoryEnvelope = exports.fixedEnvelopeFromTransaction = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const common_utils_1 = require("@riseupil/common-utils");
const envelope_1 = require("../components/envelope");
const enums_1 = require("../types/enums");
const consts_1 = require("../consts");
const utils_1 = require("../utils");
function fixedEnvelopeFromTransaction(transaction) {
    return new envelope_1.ReactiveEnvelope({
        id: `${transaction.transactionBudgetDate}#${enums_1.EnvelopeType.Fixed}#${transaction.transactionId}`,
        actuals: [transaction],
        originalAmount: (!transaction.billingAmount ? -transaction.incomeAmount : transaction.billingAmount) || 0,
        type: enums_1.EnvelopeType.Fixed,
        details: {
            businessName: transaction.businessName,
            expense: transaction.expense || consts_1.DEFAULT_FIXED_EXPENSE_CATEGORY,
            sequence: [transaction],
            sequenceId: transaction.transactionId,
            sequenceIdSource: 'reactive',
        },
        balanceDate: new Date().toLocaleDateString(),
    });
}
exports.fixedEnvelopeFromTransaction = fixedEnvelopeFromTransaction;
function createTrackingCategoryEnvelope(name, icon, amount, trackingCategoryId, budgetDate, frequency, isCustomPrediction, defaultAmount, cashflowStartDay, dateLocale) {
    if (frequency === enums_1.TrackingCategoryFrequency.Weekly) {
        return _createWeeklyEnvelopes(name, icon, amount, trackingCategoryId, budgetDate, isCustomPrediction, defaultAmount, cashflowStartDay, dateLocale);
    }
    return [_createMonthlyEnvelope(name, icon, amount, trackingCategoryId, budgetDate, isCustomPrediction, defaultAmount)];
}
exports.createTrackingCategoryEnvelope = createTrackingCategoryEnvelope;
function _createMonthlyEnvelope(name, icon, amount, trackingCategoryId, budgetDate, isCustomPrediction, defaultAmount) {
    return new envelope_1.ReactiveEnvelope({
        id: `${budgetDate}#${enums_1.EnvelopeType.TrackingCategory}#${trackingCategoryId}`,
        actuals: [],
        originalAmount: amount,
        type: enums_1.EnvelopeType.TrackingCategory,
        isCustomPrediction,
        details: {
            trackingCategory: {
                _id: trackingCategoryId,
                isEnabled: true,
                name,
                icon,
                defaultAmount,
            },
        },
    }, new Date());
}
function _createWeeklyEnvelopes(name, icon, amount, trackingCategoryId, budgetDate, isCustomPrediction, defaultAmount, cashflowStartDay, dateLocale) {
    const dailyAmount = amount / common_utils_1.daysInCashflowPeriod(budgetDate);
    const weeks = common_utils_1.getWeeks(budgetDate, cashflowStartDay, dateLocale);
    return lodash_1.default.map(weeks, week => new envelope_1.ReactiveEnvelope({
        id: `${budgetDate}#${enums_1.EnvelopeType.TrackingCategory}#${trackingCategoryId}#${week.index}`,
        actuals: [],
        originalAmount: utils_1.precision(dailyAmount * week.days),
        type: enums_1.EnvelopeType.TrackingCategory,
        isCustomPrediction,
        details: {
            weeklyIndex: week.index,
            startDate: moment_1.default(week.startDate).format('YYYY-MM-DD'),
            endDate: moment_1.default(week.endDate).format('YYYY-MM-DD'),
            trackingCategory: {
                _id: trackingCategoryId,
                isEnabled: true,
                name,
                icon,
                frequency: enums_1.TrackingCategoryFrequency.Weekly,
                defaultAmount,
            },
        },
    }, new Date()));
}
function findEconomyEnvelope(transactionDate, budgetDate, envelopes) {
    const momentTransactionDate = moment_1.default(transactionDate);
    return lodash_1.default.find(envelopes, e => (e.type === enums_1.EnvelopeType.Economy
        && moment_1.default(e.details.startDate) <= momentTransactionDate
        && momentTransactionDate < moment_1.default(e.details.endDate)));
}
exports.findEconomyEnvelope = findEconomyEnvelope;
function findRecurringEnvelope(trackingCategory, envelopes) {
    return lodash_1.default.find(envelopes, e => e.type === enums_1.EnvelopeType.Recurring && e.details.expenseCategory === trackingCategory);
}
exports.findRecurringEnvelope = findRecurringEnvelope;
function findTrackingCategoryEnvelope(trackingCategoryId, envelopes, weekInMonth) {
    // Some tracking categories have more than one envelope during the month - one for each week (i.e. economy)
    // If there is `weeklyIndex` field on the tracking category's envelope - this method will return the envelope with the
    // same `weeklyIndex` as the given `weekInMonth`. If there is no `weeklyIndex` field on the tracking category's envelope
    // (e.g. on car, eating out and all the rest) - this method will return the first (and hopefully, the only) envelope matches the category,
    // ignoring the `weekInMonth` parameter.
    return lodash_1.default.find(envelopes, e => (e.type === enums_1.EnvelopeType.TrackingCategory
        && e.details.trackingCategory._id === trackingCategoryId
        && (lodash_1.default.isUndefined(e.details.weeklyIndex) || e.details.weeklyIndex === weekInMonth)));
}
exports.findTrackingCategoryEnvelope = findTrackingCategoryEnvelope;
function findTargetTransactionsByExpenseCategory(cashflow, newExpense) {
    const reucrringEnvelope = findRecurringEnvelope(newExpense, cashflow.envelopes);
    if (reucrringEnvelope) {
        return reucrringEnvelope.actuals;
    }
    return cashflow.variableTransactions;
}
exports.findTargetTransactionsByExpenseCategory = findTargetTransactionsByExpenseCategory;
function findTargetTransactionsByTrackingCategory(cashflow, trackingCategoryId, weekInMonth) {
    const trackingCategoryEnvelope = findTrackingCategoryEnvelope(trackingCategoryId, cashflow.envelopes, weekInMonth);
    if (trackingCategoryEnvelope) {
        return trackingCategoryEnvelope.actuals;
    }
    return cashflow.variableTransactions;
}
exports.findTargetTransactionsByTrackingCategory = findTargetTransactionsByTrackingCategory;
function findSourceTransactionsByTransactionId(cashflow, transactionId) {
    const matchInVariable = lodash_1.default.find(cashflow.variableTransactions, transaction => transaction.transactionId === transactionId);
    if (matchInVariable) {
        return cashflow.variableTransactions;
    }
    const matchInExcluded = lodash_1.default.find(cashflow.excluded, transaction => transaction.transactionId === transactionId);
    if (matchInExcluded) {
        return cashflow.excluded;
    }
    const matchInVariableIncome = lodash_1.default.find(cashflow.variableIncomeTransactions, transaction => transaction.transactionId === transactionId);
    if (matchInVariableIncome) {
        return cashflow.variableIncomeTransactions;
    }
    const { actuals } = lodash_1.default.find(cashflow.envelopes, isTransactionInEnvelope(transactionId));
    return actuals;
}
exports.findSourceTransactionsByTransactionId = findSourceTransactionsByTransactionId;
function isTransactionInEnvelope(transactionId) {
    return envelope => lodash_1.default.find(envelope.actuals, t => t.transactionId === transactionId);
}
exports.isTransactionInEnvelope = isTransactionInEnvelope;
function getTransactionsByBusinessName(cashflow, businessName) {
    const matchingVariableTransactions = lodash_1.default.filter(cashflow.variableTransactions, transaction => transaction.businessName === businessName);
    const matchingNonVariableTransactions = lodash_1.default.chain(cashflow.envelopes).flatMap(e => e.actuals).filter(t => t.businessName === businessName).value();
    return [...matchingNonVariableTransactions, ...matchingVariableTransactions];
}
exports.getTransactionsByBusinessName = getTransactionsByBusinessName;
function getTransactionsByExpense(cashflow, expense) {
    return lodash_1.default.chain(cashflow.envelopes)
        .filter(e => e.type === enums_1.EnvelopeType.TrackingCategory)
        .flatMap(e => e.actuals)
        .concat(cashflow.variableTransactions)
        .filter(t => t.expense === expense)
        .value();
}
exports.getTransactionsByExpense = getTransactionsByExpense;
function getTransactionsByPaymentAppAddressee(cashflow, paymentAppAddressee) {
    return lodash_1.default.chain(cashflow.envelopes)
        .flatMap(e => e.actuals)
        .concat(cashflow.variableTransactions)
        .filter(t => t.paymentAppAddressee === paymentAppAddressee)
        .value();
}
exports.getTransactionsByPaymentAppAddressee = getTransactionsByPaymentAppAddressee;
function getTransactionById(cashflow, transactionId) {
    return lodash_1.default.find(cashflow.allTransactions, transaction => transaction.transactionId === transactionId);
}
exports.getTransactionById = getTransactionById;
function getTransactionBySplitFrom(cashflow, transactionId) {
    return lodash_1.default.filter(cashflow.allTransactions, transaction => transaction.splitFrom === transactionId);
}
exports.getTransactionBySplitFrom = getTransactionBySplitFrom;
function getEnvelopeBySequenceId(cashflow, sequenceId) {
    return lodash_1.default.find(cashflow.envelopes, envelopes => envelopes.details.sequenceId === sequenceId);
}
exports.getEnvelopeBySequenceId = getEnvelopeBySequenceId;
//# sourceMappingURL=utils.js.map